import { render, staticRenderFns } from "./zulin-project-list.vue?vue&type=template&id=c70b9dae&scoped=true"
import script from "./zulin-project-list.vue?vue&type=script&lang=js"
export * from "./zulin-project-list.vue?vue&type=script&lang=js"
import style0 from "./zulin-project-list.vue?vue&type=style&index=0&id=c70b9dae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70b9dae",
  null
  
)

export default component.exports